import React, { memo, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
	timerBox: {
		display: "flex",
		marginLeft: 10,
		marginRight: 10,
		alignItems: "center",
		minWidth: 44,
	},
}));

const padTime = (n) => (n < 10 ? `0${n}` : String(n));

/**
 * Timer de gravação isolado: atualiza o DOM via ref (sem setState a cada 1s),
 * evitando re-renders desnecessários no MessageInput durante a gravação.
 */
const RecordingTimer = memo(function RecordingTimer() {
	const classes = useStyles();
	const displayRef = useRef(null);
	const elapsedRef = useRef({ minutes: 0, seconds: 0 });

	useEffect(() => {
		elapsedRef.current = { minutes: 0, seconds: 0 };

		const renderElapsed = () => {
			const { minutes, seconds } = elapsedRef.current;
			if (displayRef.current) {
				displayRef.current.textContent = `${padTime(minutes)}:${padTime(seconds)}`;
			}
		};

		renderElapsed();

		const interval = setInterval(() => {
			const { minutes, seconds } = elapsedRef.current;
			if (seconds === 59) {
				elapsedRef.current = { minutes: minutes + 1, seconds: 0 };
			} else {
				elapsedRef.current = { minutes, seconds: seconds + 1 };
			}
			renderElapsed();
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className={classes.timerBox}>
			<span ref={displayRef}>00:00</span>
		</div>
	);
});

export default RecordingTimer;
